import axios from "axios"
import { rutas } from "../rutas/rutas"
import { getCookie } from "../utils/getCookies"

export const retiroStake = async(token, cantidad)=>{
   
        const tokenAUTH = getCookie('token')
         return axios({
            url: rutas.retiroStake,
            data: {token, cantidad},
            method: 'get',
            headers:{
                token: tokenAUTH
            }
        })
    
       
 
}
  